module.exports = __webpack_public_path__ + "static/media/4.a9af5d37.jpg";